import crypto from 'crypto';
import { encryptionKeys } from './config';

// eslint-disable-next-line consistent-return
export const encrypt = (data: string) => {
  try {
    const cipher = crypto.createCipheriv(
      encryptionKeys.algo,
      encryptionKeys.key,
      '1234123412341234',
    );

    let encryptedValue = cipher.update(data, 'utf8', 'hex');
    encryptedValue += cipher.final('hex');

    return encryptedValue;
  } catch (err) {
    console.error(err);
  }
};
